import React, { useEffect, useState } from 'react';
import { AdminSocietyWithCheckbox } from '../../TermsOfAgreement';
import { WCheckBoxGroup } from 'shared_components/components/WForms/WCheckBoxGroup/WCheckBoxGroup';

interface CheckboxListProps {
  selectAllOnChange: (checked: boolean) => void; // toggle between Select All / Unselect all
  onCheckboxChange: (id: string) => void;
  societyList: AdminSocietyWithCheckbox[];
}

const CheckboxList: React.FC<CheckboxListProps> = ({
  selectAllOnChange,
  onCheckboxChange,
  societyList,
}) => {
  const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [isCheckedAll, setIsCheckedAll] = useState<boolean>(false);
  const societyCheckBoxList = societyList.map((society) => {
    return {
      value: society.id!,
      label: society.readableName,
    };
  });

  useEffect(() => {
    // list of society ID's if society.isChecked is true
    const checkedSocieties = societyList
      .filter((society) => society.isChecked)
      .map((society) => society.id!);

    setCheckedValues(checkedSocieties);
  }, [societyList]);

  useEffect(() => {
    // iterate through societies, if all are checked set isCheckedAll to true
    const checkedSocieties = societyList.filter(
      (society) => !society.isChecked
    );

    if (checkedSocieties.length !== 0) {
      setIsCheckedAll(false);
    } else {
      setIsCheckedAll(true);
    }
  }, [societyList]);

  return (
    <div>
      <div className="">
        <WCheckBoxGroup
          name="selectAll"
          label=""
          options={
            [
              {
                value: 'select all',
                label: 'Select All',
              },
            ] as any
          }
          defaultCheckedValues={isCheckedAll ? ['select all'] : []}
          onChange={({ newValues }) => {
            selectAllOnChange(!isCheckedAll);
          }}
        />
        <WCheckBoxGroup
          name="society"
          label=""
          checkboxSize="xs"
          options={societyCheckBoxList}
          defaultCheckedValues={checkedValues}
          onChange={({ oldValues, newValues }) => {
            selectAllOnChange(false);

            // Find the changed checkbox
            const diff = oldValues.filter((x) => !newValues.includes(x));
            const diff2 = newValues.filter((x) => !oldValues.includes(x));
            // check if it was checked or unchecked
            if (diff.length > 0) {
              onCheckboxChange(diff[0]);
            } else {
              onCheckboxChange(diff2[0]);
            }
          }}
          grid="tw-grid-cols-3 tw-gap-2"
        />
      </div>
    </div>
  );
};

export default CheckboxList;
